module.exports = __webpack_public_path__ + "sj.7a4bed05693bb378bdc0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sj.svg
// module chunks = styles